import {Injectable} from '@angular/core';
import {CeContextService} from './ce-context.service';
import {BeneficiaireContextService} from './beneficiaire-context.service';
import {UserService} from '../user.service';
import {Observable} from 'rxjs/Observable';
import {Beneficiaire} from '../../models/beneficiaire/beneficiaire.model';
import {PlatformContextService} from './platform-context.service';

@Injectable()
export class ContextInitializerService {
  public constructor(
    private userService: UserService,
    private ceContext: CeContextService,
    private beneficiaireContext: BeneficiaireContextService,
    private platformContextService: PlatformContextService
  ) {
  }

  /**
   * Initialize all the context needed to the app
   */
  public initialize(): Promise<any> {
    if (this.platformContextService.isSalarie()) {
      return this.getContextSalarie();
    } else if (this.platformContextService.isElu()) {
      return this.getContextElu();
    }
  }

  getContextElu() {
    return Observable.forkJoin(
      this.userService.getCes()
    )
      .toPromise()
      .then(([ces]) => {
        this.beneficiaireContext.set(null);
        this.ceContext.set(ces[0]);
      });
  }

  getContextSalarie() {
    return Observable.forkJoin(
      this.userService.getBenef(),
      this.userService.getCes()
    )
      .toPromise()
      .then(([beneficiaire, ces]) => {
        this.beneficiaireContext.set(beneficiaire as Beneficiaire);
        this.ceContext.set(ces[0]);
      });
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/context/context-initializer.service.ts